/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CourseSegmentId } from './courseSegmentId';

/**
 * Segment of a course
 */
export interface CourseSegment {
  id?: CourseSegmentId;
  title: string;
  sortIndex?: number;
  moduleIds?: string[];
}
